import React, { useState, useEffect } from "react";
import "../styles/Home.css";

/* --------------------------------------------------
 * Home Kiosk Page (link‑only version)
 * --------------------------------------------------
 * Each tile is just an <a> tag.  No react‑router‑dom needed.
 */

const DEFAULT_ITEMS = [
  {
    id: "slot4",
    title: "Vehicles",
    caption: "Our fleet of military vehicles",
    image: "/img/vehicles/t55/t55.jpg",
    href: "/vehicles",
  },
  {
    id: "slot1",
    title: "Packages",
    caption: "Check out our packages and experiences!",
    image: "/img/3starBanner2.jpg",
    href: "/packages",
  },
  {
    id: "slot2",
    title: "Machine Guns",
    caption: "Additional shooting from our historic collection of guns.",
    image: "img/guns/_belt/minigun/minigun.jpg",
    href: "/items-catalog",
  },
  {
    id: "slot3",
    title: "Media Gallery",
    caption: "Browse today's event pictures and videos",
    image: "/img/media.jpg",
    href: "/image-gallery",
  },
];

function Home({ items = DEFAULT_ITEMS }) {
  const [showBanner, setShowBanner] = useState(true);
  const [dynamicMedia, setDynamicMedia] = useState(null);
  const [mediaType, setMediaType] = useState("image");

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowBanner(false);
    }, 10000); // 10 seconds

    return () => clearTimeout(timer);
  }, []);

  // Fetch a random image/video from the gallery for the Media Gallery tile
  useEffect(() => {
    const fetchRandomMedia = async () => {
      try {
        const response = await fetch("https://r2-image-service.t9e2i3kal.workers.dev/api/media");
        const data = await response.json();
        
        if (data.success && data.data.length > 0) {
          // Get a random media item from the gallery
          const randomIndex = Math.floor(Math.random() * data.data.length);
          const randomMedia = data.data[randomIndex];
          
          setDynamicMedia(randomMedia.url);
          
          // Determine if it's a video or image
          const fileType = randomMedia.name.toLowerCase().split(".").pop();
          const isVideo = ["mp4", "webm", "mov", "avi", "mkv", "m4v", "3gp", "flv"].includes(fileType);
          setMediaType(isVideo ? "video" : "image");
        } else {
          // Use default image if no media is available
          setDynamicMedia("/img/media.jpg");
          setMediaType("image");
        }
      } catch (error) {
        console.error("Failed to fetch dynamic media:", error);
        // Use default image if there's an error
        setDynamicMedia("/img/media.jpg");
        setMediaType("image");
      }
    };

    fetchRandomMedia();
  }, []);

  // Ensure exactly four tiles
  const slots = [...items].slice(0, 4);
  while (slots.length < 4) {
    slots.push({
      id: `placeholder-${slots.length}`,
      title: "Coming Soon",
      caption: "",
      image: "/img/home/placeholder.jpg",
      href: "#",
    });
  }

  return (
    <main
      className="home-wrapper"
      role="main"
    >
      {showBanner && (
        <div
          className="fullscreen-banner"
          onClick={() => setShowBanner(false)}
        >
          <img
            src="/images/logobanner.png"
            alt="DAT Logo Banner"
            className="fullscreen-banner-image"
          />
        </div>
      )}
      <div className="home-grid">
        {slots.map((item) => {
          // Use dynamic media for the Media Gallery tile
          const isMediaGalleryTile = item.id === "slot3";
          const backgroundImage = isMediaGalleryTile && dynamicMedia ? dynamicMedia : item.image;
          
          return (
            <a
              key={item.id}
              href={item.href || "#"}
              className="home-tile"
              aria-label={item.title}
            >
              {isMediaGalleryTile && dynamicMedia && mediaType === "video" ? (
                // Render video for Media Gallery tile if dynamic media is a video
                <video
                  src={backgroundImage}
                  className="home-tile-image"
                  autoPlay
                  loop
                  muted
                  playsInline
                />
              ) : (
                // Render image for all other tiles or if dynamic media is an image
                <img
                  src={backgroundImage}
                  alt={item.title}
                  className="home-tile-image"
                  loading="lazy"
                />
              )}
              <span className="home-tile-overlay" />
              <span className="home-tile-text">
                <span className="home-tile-title">{item.title}</span>
                {item.caption && (
                  <span className="home-tile-caption">{item.caption}</span>
                )}
              </span>
            </a>
          );
        })}
      </div>
    </main>
  );
}

export default Home;
